let autocompleteOptions = {
  types: ['(cities)'],
  componentRestrictions: { 'country': ['IN'] },
  fields: ['name', 'geometry']
};

let autocompleteService;
let placesService;
let selectedCity = { name: '', lat: null, lng: null };

// Cache array to store previous suggestions
let cachedSuggestions = [];

function initSetup() {
  const input = document.getElementById('location');
  const suggestionsEl = document.getElementById('suggestions');

  autocompleteService = new google.maps.places.AutocompleteService();
  const dummyMap = new google.maps.Map(document.createElement('div'));
  placesService = new google.maps.places.PlacesService(dummyMap);

  input.addEventListener('input', () => {
    const query = input.value.trim();
    if (!query) {
      suggestionsEl.style.border = "1px solid #ddd"
      suggestionsEl.innerHTML = '';
      return;
    }

    const filtered = cachedSuggestions.filter(item =>
      item.description.toLowerCase().includes(query.toLowerCase())
    );

    if (filtered.length > 0) {
      renderSuggestions(filtered, suggestionsEl);
    } else {
      autocompleteService.getPlacePredictions({
        input: query,
        ...autocompleteOptions
      }, (predictions, status) => {
         suggestionsEl.style.border = "1px solid #ddd"
        suggestionsEl.innerHTML = '';
        if (status === google.maps.places.PlacesServiceStatus.OK && predictions.length) {
          cachedSuggestions = predictions.map(item => item);
          renderPredictions(predictions, suggestionsEl);
        } else {
          suggestionsEl.innerHTML = '<li>No results found</li>';
        }
      });
    }
  });

  suggestionsEl.addEventListener('click', (e) => {
    const li = e.target;
    const placeId = li.dataset.placeId;
    const cityName = li.dataset.cityName;
    if (!placeId || !cityName) return;

    placesService.getDetails({
      placeId,
      fields: ['geometry']
    }, (place, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK && place.geometry) {
        selectedCity.name = cityName;
        selectedCity.lat = place.geometry.location.lat();
        selectedCity.lng = place.geometry.location.lng();

        input.value = selectedCity.name;
        suggestionsEl.innerHTML = '';
      } else {
        console.error('❌ Failed to fetch geometry');
      }
    });
  });
}

function renderSuggestions(list, container) {
  container.innerHTML = '';
  list.forEach(item => {
    const li = document.createElement('li');
    li.textContent = item.description;
    li.style.cursor = 'pointer';
    li.dataset.placeId = item.place_id;
    li.dataset.cityName = item.description;
    container.appendChild(li);
  });
}

function renderPredictions(predictions, container) {
  container.innerHTML = '';
  predictions.forEach(prediction => {
    const li = document.createElement('li');
    li.textContent = prediction.description;
    li.style.cursor = 'pointer';
    li.dataset.placeId = prediction.place_id;
    li.dataset.cityName = prediction.description;
    container.appendChild(li);
  });
}
